import React, { useState } from "react";
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from "@ant-design/icons";

import { GET_GRAPHIC_STANDS_CURSOR } from "graphql/query/graphic-stand-gql";

import GraphicStands from "components/graphic-stand";
import GraphicPacking from "components/graphic-packing";
import { Tables, TotalItems } from "components/layout";
import { Localize } from "components/service";
import { useBreadCrumbs } from "components/use-hooks";

import { gqlBuilderWhere } from 'utils';
import Icons from 'components/icons';



const basePath = GraphicPacking.Const.basePath;
const tableHelper = GraphicStands.Helpers.TableMain;


const GraphicPackingStandsSubPage = ({ graphicPacking }) => {
    const history = useHistory();

    const {
        _setGraphicStandExportExcel,
        loadingMutationGraphicStandExportExcel
    } = GraphicStands.Hooks.exportExcel();

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Graphic_Commissioning" }).props.children,
            path: `${ basePath }`
        },
        {
            label: graphicPacking?.title,
            path: `${ basePath }/${ graphicPacking?.id }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_GraphicPackedList" }).props.children,
            path: `${ basePath }/${ graphicPacking?.id }/packed-list`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    const routeUrl = `${ basePath }/${ graphicPacking?.id }${ GraphicStands.Const.basePath }`;

    const objOrderBy = [ { column: "ID", order: "DESC" } ];

    const filterTable = 'table-graphic-stands';

    const graphicStandsFilters = JSON.parse(localStorage.getItem(`graphicStandsFilters-${ filterTable }_graphicPackingID-${ graphicPacking?.id }`));
    const graphicStandsSorting = JSON.parse(localStorage.getItem(`graphicStandsSorting-${ filterTable }_graphicPackingID-${ graphicPacking?.id }`));
    const graphicStandsSearch = JSON.parse(localStorage.getItem(`graphicStandsSearch-${ filterTable }_graphicPackingID-${ graphicPacking?.id }`));

    const [ searchText, setSearchText ] = useState(graphicStandsSearch);
    const [ filters, setFilters ] = useState(gqlBuilderWhere(graphicStandsFilters));
    const [ resetSorting, setResetSorting ] = useState(false);



    return (
        <Tables.Cursor
            extraClass="table-graphic-stands"
            tableLayout=""
            model="graphicStandsCursor"
            query={ GET_GRAPHIC_STANDS_CURSOR }
            currentObj={ graphicPacking }
            varSet={ {
                perPage: 30,
            } }
            routeUrl={ routeUrl }
            searchText={ searchText }
            objFilter={ {
                AND: [
                    {
                        column: 'GRAPHIC_LIST_ID',
                        value: graphicPacking?.id
                    },
                    ...(!filters ? [] : Array.isArray(filters) ? filters : [ filters ])
                ]
            } }
            objOrderBy={ graphicStandsSorting || objOrderBy }
            sortingName={ `graphicStandsSorting-${ filterTable }_graphicPackingID-${ graphicPacking?.id }` }

            tableHelper={ tableHelper }
            resetSorting={ resetSorting }
            filterTable={ filterTable }
        >
            { ({ pageInfo, model }) => (
                <div className="table-action-bar">

                    <div className="col">

                        <GraphicStands.Filters.Table
                            excludeFields={ [ 'STATUS' ] }
                            graphicPacking={ graphicPacking }
                            setSearchText={ setSearchText }
                            setFilters={ setFilters }
                            filters={ filters }
                            graphicStandsFilters={ graphicStandsFilters }
                            searchText={ searchText }
                            setResetSorting={ setResetSorting }
                            objOrderBy={ objOrderBy }
                        />

                        <TotalItems
                            pageInfo={ pageInfo }
                        />

                    </div>

                    <div className="col">
                        <Button
                            type='outline'
                            style={ { maxWidth: '100%' } }
                            onClick={ () => _setGraphicStandExportExcel(graphicPacking?.id) }
                            loading={ loadingMutationGraphicStandExportExcel }
                        >
                            <Icons.Download />&nbsp;&nbsp;<Localize>GLOBAL.Button_Text_ExportExel</Localize>
                        </Button>
                        <Button
                            type="primary"
                            onClick={ () => history.push(`${ basePath }/${ graphicPacking?.id }/stands`) }
                            style={ {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '4px'
                            } }
                        >
                            <ArrowLeftOutlined style={ { fontSize: '16px', marginTop: '1px' } } />
                            <Localize>GLOBAL.Button_Text_BackGraphicChoise</Localize>
                        </Button>
                    </div>
                </div>) }
        </Tables.Cursor>
    );
};

export default GraphicPackingStandsSubPage;